export const theme = {
  colors: {
    base: '#fffafa',
    point: '#ba727a',
  },
};
